import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=0f8d9c1e&scoped=true"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=0f8d9c1e&prod&lang=css"
import style1 from "./OrgChart.vue?vue&type=style&index=1&id=0f8d9c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d9c1e",
  null
  
)

export default component.exports